enum RequestedFeature {
  ApplyTradeIn = 'ApplyTradeIn',
  ApplyVerboseLogging = 'ApplyVerboseLogging',
  ConditionalTiles = 'ConditionalTiles',
  ConsolidatedSuggestedFilters = 'ConsolidatedSuggestedFilters',
  DealershipConditionalTiles = 'DealershipConditionalTiles',
  EarliestAcquisitionBoosting = 'EarliestAcquisitionBoosting',
  ExcludeFacetData = 'ExcludeFacetData',
  ExcludeFinanceConditionalTiles = 'ExcludeFinanceConditionalTiles',
  FetchTradeIn = 'FetchTradeIn',
  HideImpossibleCombos = 'HideImpossibleCombos',
  LocationBasedPrefiltering = 'LocationBasedPrefiltering',
  LoanTermPricing = 'LoanTermPricing',
  Personalization = 'Personalization',
  ShaqvanaConditionalTile = 'ShaqvanaConditionalTile',
  Sprinkles = 'Sprinkles'
}

export default RequestedFeature;
